<div class="vertical seperate body top basic-block">
  <a href="https://peakmojo.ai">
    <img class="logo" width="30px" src="/assets/icons/logo.png" />
  </a>

  <div class="vertical">
    <div class="title">Scheduled Maintenance in Progress</div>

    <div class="content">{{ getContent() }}</div>
  </div>
</div>
